import { useState, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api';
import { saveToken } from '../utils/token';
import Toast from '../components/Toast';

export default function Register() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);
  const navigate = useNavigate();

  const showToast = (message, type = 'success') => setToast({ message, type });
  const clearToast = useCallback(() => setToast(null), []);

  const handleRegister = async () => {
    if (!name.trim() || !email.trim() || !password.trim()) {
      showToast('Completá todos los campos', 'error');
      return;
    }
    setLoading(true);
    try {
      const res = await api.post('/auth/register', { name, email, password });
      saveToken(res.data.token);
      localStorage.setItem('userId', res.data.userId);
      localStorage.setItem('userName', name);
      showToast('¡Cuenta creada! Redirigiendo...');
      setTimeout(() => navigate('/home'), 1500);
    } catch (err) {
      const msg = err.response?.data?.error || err.response?.data?.message || 'Error al registrar';
      showToast(msg, 'error');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => { if (e.key === 'Enter') handleRegister(); };

  return (
    <div className="register-container">
      {toast && <Toast message={toast.message} type={toast.type} onClose={clearToast} />}
      <div className="register-card">
        <h2>🐮 Únete a VaquitApp 🐮</h2>
        <p className="welcome-text">
          ¡Bienvenido! Crea tu cuenta para empezar a organizar vaquitas con tus amigos
        </p>

        <div className="register-form">
          <div className="input-group">
            <label>Nombre</label>
            <input
              type="text"
              placeholder="Tu nombre completo"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={handleKeyDown}
              className="register-input"
              disabled={loading}
            />
          </div>

          <div className="input-group">
            <label>Email</label>
            <input
              type="email"
              placeholder="tu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={handleKeyDown}
              className="register-input"
              disabled={loading}
            />
          </div>

          <div className="input-group">
            <label>Contraseña</label>
            <input
              type="password"
              placeholder="Tu contraseña segura"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
              className="register-input"
              disabled={loading}
            />
          </div>

          <button onClick={handleRegister} className="register-button" disabled={loading}>
            {loading ? 'Creando cuenta...' : 'Crear cuenta 🐄'}
          </button>
        </div>

        <p className="login-link">
          ¿Ya tienes cuenta? <Link to="/">Inicia sesión aquí</Link>
        </p>
      </div>

      <style jsx>{`
        .register-container {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem;
          background: var(--bg-primary);
        }

        .register-card {
          background: var(--bg-secondary);
          padding: 2rem;
          border-radius: 8px;
          box-shadow: 0 2px 4px var(--shadow-color);
          width: 100%;
          max-width: 400px;
        }

        h2 {
          text-align: center;
          color: var(--text-primary);
          margin-bottom: 1rem;
        }

        .welcome-text {
          text-align: center;
          color: var(--text-muted);
          margin-bottom: 2rem;
        }

        .register-form {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .input-group {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        label {
          color: var(--text-secondary);
          font-size: 0.9rem;
        }

        .register-input {
          padding: 0.8rem;
          border: 1px solid var(--border-color);
          border-radius: 4px;
          font-size: 1rem;
          transition: border-color 0.2s;
          background: var(--bg-secondary);
          color: var(--text-secondary);
        }

        .register-input:focus {
          outline: none;
          border-color: var(--accent-color);
        }

        .register-button {
          background: var(--accent-color);
          color: white;
          border: none;
          padding: 1rem;
          border-radius: 4px;
          font-size: 1rem;
          cursor: pointer;
          transition: background 0.2s;
          margin-top: 1rem;
        }

        .register-button:hover:not(:disabled) {
          background: var(--accent-hover);
        }

        .register-button:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }

        .login-link {
          text-align: center;
          margin-top: 1.5rem;
          color: var(--text-muted);
        }

        .login-link a {
          color: var(--accent-color);
          text-decoration: none;
        }

        .login-link a:hover {
          text-decoration: underline;
        }
      `}</style>
    </div>
  );
}
